import { Node } from 'tiptap';

export default class WarningInput extends Node {
  // eslint-disable-next-line class-methods-use-this
  get name() {
    return 'warningInput';
  }

  // eslint-disable-next-line class-methods-use-this
  get view() {
    return {
      props: ['node'],
      computed: {
        spanClass() {
          if (this.node.attrs.class === 'alert-primary') {
            return 'info-input';
          }
          if (this.node.attrs.class === 'alert-warning') {
            return 'disclaimer-input';
          }
          return 'warning-input';
        },
      },
      template: `
        <div :class="'flex alert ' + node.attrs.class" data-type="info-panel">
           <span :class="spanClass" ref="content" >
           </span>
        </div>
      `,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  get schema() {
    return {
      inline: true,
      attrs: {
        class: {
          default: null,
        },
        inputClass: {
          default: null,
        },
        icon: {
          default: null,
        },
        type: {
          default: 'text',
        },
        panel: {
          default: null,
        },
      },
      group: 'inline',
      content: 'text*',
      size: 'text*',
      toDOM: node => {
        return [
          'div',
          {
            class: node.attrs.class,
            'data-type': 'info-panel',
          },
          [
            'span',
            {
              class: node.attrs.inputClass,
              ref: 'content',
            },
            0,
          ],
        ];
      },
      parseDOM: [
        {
          tag: `div[data-type="info-panel"]`,
          getAttrs: dom => ({
            class: dom.getAttribute('class'),
          }),
        },
      ],
    };
  }

  // eslint-disable-next-line class-methods-use-this
  commands({ type }) {
    return attrs => (state, dispatch) => {
      const { selection } = state;
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos;
      const node = type.create(attrs);
      const transaction = state.tr.insert(position, node);
      dispatch(transaction);
    };
  }
}



// WEBPACK FOOTER //
// ./src/includes/warning.js